import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Vuelidate from 'vuelidate'
import VueResource from 'vue-resource'
import { mapState, mapActions, mapGetters } from 'vuex'
import Rollbar from 'vue-rollbar'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueResource)
Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.NODE_ENV
  }
})

Vue.http.interceptors.push(function (request, next) {
  request.headers.set('Content-Type', 'application/json')
  request.headers.set('Accept', 'application/json')
  request.headers.set('Cache-Control', 'no-cache, no-store')
  request.headers.set('x-auth-token', (store.state.userAuthToken ? store.state.userAuthToken[store.state.chosenStudy.studyName] : null))
  next()
})

Vue.mixin({
  computed: {
    ...mapState(['chosenStudy', 'userLang', 'userId', 'userStudyIdentifier', 'studyConsent', 'qnBuddyBotId']),
    ...mapGetters(['localisation'])
  },
  methods: {
    ...mapActions(['initializeChosenStudy', 'updateUserParameters', 'updateUserLogout'])
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === 'NotFound') {
    next()
  } else if (!store.state.studies.hasOwnProperty(to.params.studyName)) {
    next({ name: 'NotFound' })
  } else if (store.state.userId === null || !store.state.userAuthToken.hasOwnProperty(to.params.studyName)) {
    if (to.name === 'Login') {
      next()
    } else {
      next({ path: `/${to.params.studyName}` })
    }
  } else if (!store.state.studyConsent) {
    if (to.name === 'RequestConsent') {
      next()
    } else {
      next({ path: `/${to.params.studyName}/consent` })
    }
  } else if (store.state.studyConsent === true) {
    if (to.name === 'Manage') {
      next()
    } else {
      next({ path: `/${to.params.studyName}/manage` })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
